<template>
  <div>
    <Head :top="scrollTop"/>
    <div class="container">
      <router-view :key="key"/>
    </div>
    <Bottom/>
  </div>
</template>

<style lang="less">
@import '~@/assets/style1/css/index.less';
</style>

<script>
import Head from '@/components/style1/Head.vue';
import Bottom from '@/components/style1/Bottom.vue';

export default {
  name: 'AppVue',
  components: {
    Head, Bottom,
  },
  data() {
    return {
      scrollTop: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll); // 监听页面滚动
  },
  computed: {
    key() {
      return this.$route.name ? this.$route.name + +new Date() : this.$route + +new Date();
    },
  },
  methods: {
    // 获取页面滚动距离
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop
        || document.body.scrollTop;
    },
  },

};
</script>
